import { render } from "./ProjectSearchWidget.vue?vue&type=template&id=1667362b&ts=true"
import script from "./ProjectSearchWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectSearchWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__